<template>
    <ToggleSelector v-model="selectedOption" :options="options" toggleStyle="light-gray" />
</template>
<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue'
import ToggleSelector from '@/components/ToggleSelector.vue'

type PricingOption = 'single' | 'subscription'

const options = [
    {
        value: 'single',
        label: 'Single purchase',
        imgUrl: '/img/emojis/emoji-greeting-card.svg',
    },
    {
        value: 'subscription',
        label: 'Team plan',
        imgUrl: '/img/emojis/emoji-celebration.svg',
    },
]

const selectedOption = ref<PricingOption>('single')

function updateVisibility() {
    const singleOption = document.getElementById('pricing-single')
    const subscriptionOption = document.getElementById('pricing-subscription')

    if (selectedOption.value === 'single') {
        singleOption?.classList?.remove('hidden')
        subscriptionOption?.classList?.add('hidden')
        history.replaceState(history.state, '', location.pathname + location.search)
    } else {
        singleOption?.classList?.add('hidden')
        subscriptionOption?.classList?.remove('hidden')
        history.replaceState(history.state, '', '#subscription')
    }
}

watch(selectedOption, () => {
    updateVisibility()
})

onMounted(() => {
    if (window.location.hash === '#subscription') {
        selectedOption.value = 'subscription'
    }

    nextTick(() => {
        updateVisibility()
    })
})
</script>
<style scoped>
.selector {
    @apply absolute inset-y-0 left-0 m-1 bg-purple transform rounded-full;
    width: calc(50% - 0.25rem);
    transition:
        transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
